import { Leaderboard, UserLeaderboardRank } from "@mezo/api"
import { createSlice } from "@reduxjs/toolkit"

type LeaderboardState = {
  fullLeaderboard: Leaderboard
  currentUser: UserLeaderboardRank
  isFullyFetched: boolean
}

const initialState: LeaderboardState = {
  fullLeaderboard: { leaderboard: [], users: 0 },
  currentUser: { rank: null, score: 0 },
  isFullyFetched: false,
}

export const leaderboardSlice = createSlice({
  name: "leaderboard",
  initialState,
  reducers: {
    setLeaderboard: (immerState, { payload }: { payload: Leaderboard }) => {
      immerState.fullLeaderboard = payload
    },
    setCurrentUserLeaderboard: (
      immerSate,
      { payload }: { payload: UserLeaderboardRank },
    ) => {
      immerSate.currentUser = payload
    },
    setLeaderboardFullyFetched: (
      immerState,
      { payload }: { payload: boolean },
    ) => {
      immerState.isFullyFetched = payload
    },
  },
})

export const {
  setLeaderboard,
  setCurrentUserLeaderboard,
  setLeaderboardFullyFetched,
} = leaderboardSlice.actions

export default leaderboardSlice.reducer
